import Needs from "@/views/needs/needs/Needs.vue";
import Need from "@/views/needs/need/Need.vue";
import NeedsDashboard from "@/views/enterprise/NeedsDashboard.vue";

export default [
    {
        path: '/needs',
        component: Needs,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs-dashboard',
        component: NeedsDashboard,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs/:id',
        component: Need,
        meta: {
            access: ['enterprise']
        }
    },
]
